import { render, staticRenderFns } from "./listadoClientesProspectos.vue?vue&type=template&id=f2f10a80"
import script from "./listadoClientesProspectos.vue?vue&type=script&lang=js"
export * from "./listadoClientesProspectos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports